import React, { useState } from 'react';
import { Box, CardContent, Typography } from '@mui/material';
import { Repeat } from '@mui/icons-material';
import { PageContainer, PageCard, SectionHeader } from '../../common/components/styled-ui-elements';
import { BackToDashboardButton } from '../../common/components/navigation';
import { RecurringTasksGrid } from '../components/RecurringTaskList';
import { RecurringTaskSearch } from '../components/RecurringTaskForm/fields';
import { CreateRecurringTaskButton } from '../components/RecurringTaskForm/actions';

const RecurringTasksList: React.FC = () => {
  const [searchText, setSearchText] = useState('');
  const [showInactive, setShowInactive] = useState(false);

  return (
    <PageContainer sx={{ backgroundColor: '#f8fafc' }}>
      <Box display="flex" justifyContent="center">
        <PageCard>
          {/* Professional Header */}
          <Box sx={{ 
            backgroundColor: '#ffffff',
            borderBottom: '2px solid #3b82f6',
            p: 2.5
          }}>
            <Box display="flex" justifyContent="space-between" alignItems="flex-start">
              <Box>
                <SectionHeader 
                  icon={<Repeat sx={{ mr: 1, color: '#3b82f6' }} />}
                  title="Recurring Tasks"
                />
                <Typography 
                  variant="body2" 
                  sx={{ color: '#64748b', ml: 4 }}
                >
                  Manage automated ticket templates and schedules
                </Typography>
              </Box>
              <Box display="flex" gap={1}>
                <CreateRecurringTaskButton />
                <BackToDashboardButton />
              </Box>
            </Box>
          </Box>
          
          <CardContent sx={{ p: 3, backgroundColor: '#ffffff' }}>
            {/* Search and Filter Section */}
            <RecurringTaskSearch 
              searchText={searchText}
              onSearchChange={setSearchText}
              showInactive={showInactive}
              onShowInactiveChange={setShowInactive}
            />

            {/* Grid Section */}
            <RecurringTasksGrid 
              searchText={searchText}
              showInactive={showInactive}
            />
          </CardContent>
        </PageCard>
      </Box>
    </PageContainer>
  );
};

export default RecurringTasksList;
